export class StreamProxy {
  // convert https://streamer.radio.co/sa357a791a/listen
  // into https://stream.fabriccamultimidia.com/streamer.radio.co/sa357a791a/listen
  static addProxy(url?: string): string {
    if (!url) return "";
    const proxy = window.location.hostname.includes("fabriccamultimidia.com")
      ? "https://stream.fabriccamultimidia.com/"
      : "https://stream.fabricca.pro/";
    return url.replace("https://", proxy);
  }

  // convert https://stream.fabriccamultimidia.com/streamer.radio.co/sa357a791a/listen
  // into https://streamer.radio.co/sa357a791a/listen
  static removeProxy(url?: string): string {
    if (!url) return "";
    return url
      .replace("https://stream.fabriccamultimidia.com/", "https://")
      .replace("https://stream.fabricca.pro/", "https://");
  }

  static hasProxy(url?: string): boolean {
    if (!url) return false;
    return url !== StreamProxy.removeProxy(url);
  }

  static toggleProxy(url?: string): string {
    if (!url) return "";
    return StreamProxy.hasProxy(url)
      ? StreamProxy.removeProxy(url)
      : StreamProxy.addProxy(url);
  }
}
